import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";
import { ReactComponent as Logo } from "../img/aiia.svg";
import { AdminService, UserService } from "../generated";

export class NavMenu extends Component<
  {},
  {
    logged: boolean;
    isAdmin: boolean;
    loading: boolean;
    collapsed: boolean;
  }
> {
  constructor(props: {}) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      loading: true,
      logged: false,
      isAdmin: false,
      collapsed: false,
    };
  }

  async componentDidMount() {
    const isAuthenticated = await UserService.userIsAuthenticated();
    if (isAuthenticated) {
      await this.checkIfAdmin();
    }

    this.setState({
      loading: false,
      logged: isAuthenticated,
    });
  }

  async checkIfAdmin() {
    try {
      var testAdmin = await AdminService.adminPing();

      this.setState({
        isAdmin: Object.prototype.hasOwnProperty.call(testAdmin, "pong"),
      });
    } catch {
      this.setState({
        isAdmin: false,
      });
    }
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    return (
      <header>
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm ng-white my-3 py-3"
          light
          container={"lg"}
        >
          <NavbarBrand
            tag={Link}
            to="/"
            className="font-weight-bold"
            style={{ fontSize: "2em" }}
          >
            <Logo
              style={{
                verticalAlign: "middle",
                maxHeight: "40px",
              }}
            />
          </NavbarBrand>

          <Nav navbar>
            {this.state.isAdmin ? (
              <>
                <NavItem>
                  <NavLink href="admin/create">Start mission!</NavLink>
                </NavItem>

                <NavItem>
                  <NavLink href="admin/missions">My missions</NavLink>
                </NavItem>

                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Manage testers
                  </DropdownToggle>
                  <DropdownMenu end>
                    {/* <DropdownItem>
                      <NavLink href="admin/invite">Invite</NavLink>
                    </DropdownItem>
                    <DropdownItem divider /> */}
                    <DropdownItem>
                      <NavLink href="admin/users/all">All testers</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink href="admin/users/active">
                        Active testers
                      </NavLink>
                    </DropdownItem>
                    {/* <DropdownItem>
                      <NavLink href="admin/users/invited">
                        Invited testers
                      </NavLink>
                    </DropdownItem> */}
                  </DropdownMenu>
                </UncontrolledDropdown>

                <NavItem></NavItem>
                <NavItem></NavItem>
                <NavItem></NavItem>
              </>
            ) : null}
            <NavItem className="px-2">
              {this.state.logged ? (
                <a
                  className="text-dark btn border border-dark px-4"
                  href="/signout"
                >
                  Logout
                </a>
              ) : (
                <a
                  className="text-dark btn border border-dark px-4"
                  href="/signin"
                >
                  Login
                </a>
              )}
            </NavItem>
          </Nav>
        </Navbar>
      </header>
    );
  }
}
